import { useMemo } from 'react';
import useOrganizationConfig from '@/api/core/organization-config/useOrganizationConfig';

// TODO DEMO - remove and use value from db.
import rexelLogo from 'src/assets/logos/rexel.ca-logo-3.jpg';

export function useOrganizationLogo() {
  const { data: orgConfigRes, isLoading, error } = useOrganizationConfig();

  const logoUrl = useMemo(() => {
    // Logo URL logic from legacy sidenav
    if (orgConfigRes?.organizationConfig?.logoUrl) {
      return orgConfigRes.organizationConfig.logoUrl;
    }

    const orgName = orgConfigRes?.organizationConfig?.organization?.name
      ?.trim()
      ?.toLowerCase();

    if (orgName?.includes('rexel')) {
      return rexelLogo;
    }

    return null;
  }, [
    orgConfigRes?.organizationConfig?.logoUrl,
    orgConfigRes?.organizationConfig?.organization?.name,
  ]);

  const organizationName =
    orgConfigRes?.organizationConfig?.organization?.name ?? 'Organization';

  return {
    logoUrl,
    organizationName,
    isLoading,
    error,
  };
}
